"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(state, windowId) {
    if (state &&
        state.layout &&
        state.layout.window &&
        state.layout.window.items &&
        state.layout.window.items.has(windowId)) {
        return state.layout.window.items.get(windowId);
    }
}
exports.default = default_1;
//# sourceMappingURL=getWindowItem.js.map